module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-cbff58a3.png";